.filterText {
	font-weight: bold;
}
